import React, { FunctionComponent } from 'react';
import { Container, Header, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  header: {
    display: 'flex !important',
    paddingTop: '1.875em !important',
  },
  headerText: {
    color: '#440C7F !important',
  },
  link: {
    marginLeft: 'auto !important',
  },
};

type Props = {
  searchType: string;
  searchText: string;
  classes: ClassProp<typeof styles>;
};

type Labels = {
  [key: string]: string;
};

const labels: Labels = {
  postalCode: 'Zip Code',
  cardNetworkId: 'CNID',
  addressSearchString: 'Address',
  VMID: 'VMID',
};

const SearchHeader: FunctionComponent<Props> = ({
  searchType,
  searchText,
  classes,
}) => (
  <Container className={classes.header}>
    <Header as="h3" floated="left" className={classes.headerText}>
      {`Results for ${labels[searchType]} - "${searchText}"`}
    </Header>
    <Link className={classes.link} to="/">
      <Icon name="arrow alternate circle left outline" />
      Back to All Merchants
    </Link>
  </Container>
);

export default withStyles(styles)(SearchHeader);
